import React from "react"
import PropTypes from "prop-types"

import {Col} from "@irati/ui/src/Layout"
import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Typography"

import {MAX_RESULTS_PER_SECTION} from "../../../../constants/search"
import Deals from "./Deals"
import DealBrandResults from "../../../DealBrandResults"

const SearchBarResults = (props) => {
  const {results, onClick, searchTerm, isRewards, dealBrands} = props
  const idNamespace = id("search-bar-results", props)
  return (
    <div id={idNamespace}>
      <Col md={12} marginBottom={5}>
        {!isRewards && (
          <div>
            <DealBrandResults dealBrands={dealBrands} onClick={onClick} />
          </div>
        )}
        <H3 marginBottom={1}>
          {isRewards ? (
            <FormattedMessage id="perks.components.searchPopup.rewardsHeading" />
          ) : (
            <FormattedMessage id="perks.components.searchPopup.perksHeading" />
          )}
        </H3>
        <Deals onClick={onClick} id="search" results={results[0]} maxResultsPerSection={MAX_RESULTS_PER_SECTION} searchTerm={searchTerm} />
      </Col>
    </div>
  )
}

SearchBarResults.propTypes = {
  results: PropTypes.array.isRequired,
  dealBrands: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  isRewards: PropTypes.bool
}

export default SearchBarResults
